export default "__VITE_ASSET__hbrtlARe__"